module.exports = __webpack_public_path__ + "static/media/S1-23-Malbai-cod43.80231297.png";